import { Link } from "react-router-dom";
import { comicCategories } from "@/mocks/comicData";

export default function CategoryNav() {
  return (
    <section className="py-8 md:py-10">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 flex-wrap justify-center">
          {comicCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={cat.slug === "all" ? "/category/all" : `/category/${cat.slug}`}
              className="flex items-center gap-2 px-4 py-2.5 rounded-full bg-background-100 hover:bg-background-200 text-sm font-medium text-foreground-700 hover:text-foreground-950 transition-all whitespace-nowrap cursor-pointer"
            >
              <i className={`${cat.icon} text-base w-4 h-4 flex items-center justify-center`}></i>
              {cat.name}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}